@if (!hideCounter()) {
  <div class="text caption bold primary steps" [class.right]="!count()">
    @if (count()) {
      {{ 'PROGRESS_BAR.STEP' | translate }} {{ index() + 1 }} / {{ count() }}
    } @else {
      {{ progressValue() | number: '1.0-0' }} %
    }
  </div>
}
<mat-progress-bar mode="determinate" [value]="progressValue()"></mat-progress-bar>
